import React from "react";

function WbsIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 10.84 8.808" className={className}>
      <path
        d="M1.694,10.15H.339A.339.339,0,0,0,0,10.489v1.355a.339.339,0,0,0,.339.339H1.694a.339.339,0,0,0,.339-.339V10.489A.339.339,0,0,0,1.694,10.15Zm0-6.775H.339A.339.339,0,0,0,0,3.714V5.069a.339.339,0,0,0,.339.339H1.694a.339.339,0,0,0,.339-.339V3.714A.339.339,0,0,0,1.694,3.375Zm0,3.388H.339A.339.339,0,0,0,0,7.1V8.456A.339.339,0,0,0,.339,8.8H1.694a.339.339,0,0,0,.339-.339V7.1A.339.339,0,0,0,1.694,6.763ZM10.5,10.489H3.726a.339.339,0,0,0-.339.339v.678a.339.339,0,0,0,.339.339H10.5a.339.339,0,0,0,.339-.339v-.678A.339.339,0,0,0,10.5,10.489Zm0-6.775H3.726a.339.339,0,0,0-.339.339V4.73a.339.339,0,0,0,.339.339H10.5a.339.339,0,0,0,.339-.339V4.053A.339.339,0,0,0,10.5,3.714Zm0,3.388H3.726a.339.339,0,0,0-.339.339v.678a.339.339,0,0,0,.339.339H10.5a.339.339,0,0,0,.339-.339V7.44A.339.339,0,0,0,10.5,7.1Z"
        transform="translate(0 -3.375)"
      />
    </svg>
  );
}

export { WbsIcon };
